import React, { useState, useEffect, useContext } from 'react'

import styles from './DetallePregunta.module.css'
import Modal from '../Modals'
import btnEliminar from '../../img/btneliminar.png'

import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'
import GeneralContext from '../../context/GeneralContext'

const DetallePreguntaAdicional = ({ state, setState, tipo, pregunta }) => {
    
    const { state: generalState } = useContext(GeneralContext)
    
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]
    
    const initialState = {
        otrosSeguros: [
            {
                numeroDetalleOtroSeguro: null,
                codigoTipoAsegurado: '',
                compania: '',
                anioEmision: '',
                tipoPlan: '',
                sumaAsegurada: '',
                prestamo: ''
            }
        ],
        respuestasDetalle: [
            {
                codigoAsegurado: 0
            }
        ],
        asegurados: [],
        textos: []
    }

    const [ localState, setLocalState ] = useState(initialState)
    const [ mostrarModa, setMostrarModa ] = useState(false)
   
    const textos1 = ['¡Alerta!', 'Ha ingresado el máximo de seguros permitidos.']
    const textos2 = ['¡Alerta!', 'Ha ingresado el máximo de asegurados permitidos.']
    const textos3 = ['¡Alerta!', 'Ya ha seleccionado este asegurado anteriormente.']

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }
    
    useEffect(() => {
        //Cargar Información Detalle - Tipo 1
        if(tipo === 1) {
            let otrosSeguros = state.aseguradoAdicional.otrosSeguros
            if(otrosSeguros !== null && otrosSeguros.length > 0) {
                setLocalState((localState) => {
                    return {
                        ...localState,
                        otrosSeguros: state.aseguradoAdicional.otrosSeguros
                    }
                })
            } else {
                setState((state) => {
                    return {
                        ...state,
                        aseguradoAdicional: {
                            ...state.aseguradoAdicional,
                            otrosSeguros: localState.otrosSeguros
                        }
                    }
                })
            }
        }

        //Cargar Información Detalle - Tipo 2
        if(tipo === 2) {
            let respuestasDetalle = []
            let respuestaAsegurado = state.aseguradoAdicional.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                && respuesta.respuesta === 1)[0]
            let respuestaConyuge = state.conyuge !== null && state.conyuge !== undefined && state.conyuge.respuestas !== undefined
                ? (state.conyuge && state.conyuge.respuestas) && state.conyuge.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                    && respuesta.respuesta === 1)[0] : null

            if(respuestaAsegurado !== undefined && respuestaAsegurado !== null) {
                respuestasDetalle.push({
                    codigoAsegurado: 1
                })
            }
            if(respuestaConyuge !== undefined && respuestaConyuge !== null) {
                respuestasDetalle.push({
                    codigoAsegurado: 2
                })
            }

            if(respuestasDetalle.length === 0) {
                respuestasDetalle = [
                    {
                        codigoAsegurado: 0
                    }
                ]
            }

            setLocalState((localState) => {
                return {
                    ...localState,
                    respuestasDetalle: respuestasDetalle
                }
            })
        }
    }, [ state.conyuge ])

    const mostrarPopup = (caso) => {
        setLocalState((localState) => {
            return {
                ...localState,
                textos: caso === 1 ? textos1 : caso === 2 ? textos2 : caso === 3 ? textos3 : []
            }
        })
        setMostrarModa(!mostrarModa)
    }

    const handleAgregarUno = () => {
        let otrosSeguros = localState.otrosSeguros
        otrosSeguros.push({
            numeroDetalleOtroSeguro: null,
            codigoTipoAsegurado: '',
            compania: '',
            anioEmision: '',
            tipoPlan: '',
            sumaAsegurada: '',
            prestamo: ''
        })
        setLocalState((localState) => {
            return {
                ...localState,
                otrosSeguros: otrosSeguros
            }
        })
    }

    const handleDeleteAdicionalUno = (index) => {
        const otrosSeguros = localState.otrosSeguros
        otrosSeguros.splice(index, 1)
        setLocalState((localState) => {
            return {
                ...localState,
                otrosSeguros: otrosSeguros
            }
        })
        setState((state) => {
            return {
                ...state,
                aseguradoAdicional: {
                    ...state.aseguradoAdicional,
                    otrosSeguros: otrosSeguros
                }
            }
        })
    }

    const handleAgregarDos = () => {
        let respuestasDetalle = localState.respuestasDetalle
        respuestasDetalle.push({
            codigoAsegurado: 0
        })
        setLocalState((localState) => {
            return {
                ...localState,
                respuestasDetalle: respuestasDetalle
            }
        })
    }

    const handleDeleteAdicionalDos = (index, respuestaDetalle) => {
        //Elimación Global
        if(respuestaDetalle.codigoAsegurado === 1) {
            let respuestasAsegurado = state.aseguradoAdicional.respuestas.filter(respuesta => respuesta.idBancoPregunta !== pregunta.idBancoPregunta)
            setState((state) => {
                return {
                    ...state,
                    aseguradoAdicional: {
                        ...state.aseguradoAdicional,
                        respuestas: respuestasAsegurado
                    }
                }
            })
        } else if(respuestaDetalle.codigoAsegurado === 2) {
            let respuestasConyuge = state.conyuge.respuestas.filter(respuesta => respuesta.idBancoPregunta !== pregunta.idBancoPregunta)
            setState((state) => {
                return {
                    ...state,
                    conyuge: {
                        ...state.aseguradoAdicional,
                        respuestas: respuestasConyuge
                    }
                }
            })
        }

        //Eliminación Local
        let respuestasDetalle = localState.respuestasDetalle.filter((respuestaDetalleAux, indexAux) => indexAux !== index)
            setLocalState((localState) => {
                return {
                    ...localState,
                    respuestasDetalle: respuestasDetalle
                }
            })
    }

    const cambiarValor = (index, campo, valor, campoValida) => {
        let otrosSeguros = localState.otrosSeguros
        otrosSeguros[index][campo] = valor
        setLocalState((localState) => {
            return {
                ...localState,
                otrosSeguros: otrosSeguros
            }
        })
        let campoValidacion = state.campoValidadoAdicional[campoValida]
        campoValidacion[index] = true
        setState((state) => {
            return {
                ...state,
                aseguradoAdicional: {
                    ...state.aseguradoAdicional,
                    otrosSeguros: otrosSeguros
                },
                campoValidadoAdicional: {
                    ...state.campoValidadoAdicional,
                    [campoValida]: campoValidacion
                }
            }
        })
    }

    const handleChangeTitular = (e, campo, index) => {
        cambiarValor(index, campo, parseInt(e.target.value), 'titular')
    }

    const handleChangeTexto = (e, campo, index) => {
        let valor = e.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, "")
        let capital = valor.replace(/\b\w/g, l => l.toUpperCase())
        cambiarValor(index, campo, capital, campo)
    }

    const handleAnio = (e, campo, index) => {
        let valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, '')
        cambiarValor(index, campo, parseInt(valor), 'emision')
    }

    const handleChangeSuma = (e, campo, index) => {
        cambiarValor(index, campo, Funciones.cantidadStringToFloat(e.target.value), 'sumaAsegurada')
    }

    const handleChangePrestamo = (e, campo, index) => {
        cambiarValor(index, campo, parseInt(e.target.value), 'prestamo')
    }

    const handleChangeCombo = (e, campo, index, respuestaDetalle) => {
        const valor = parseInt(e.target.value)
        //Validar la repetición
        let respuestaDetalleAux = localState.respuestasDetalle.filter(respuestaDetalleAux =>
            respuestaDetalleAux.codigoAsegurado.toString() === valor.toString())[0]
        if(respuestaDetalleAux !== undefined && respuestaDetalleAux !== null) {
            mostrarPopup(3)
        } else {
            if(respuestaDetalle.codigoAsegurado === 1) {
                //Actualización Global
                //Eliminación
                let respuestasAsegurado = state.aseguradoAdicional.respuestas.filter(respuesta => respuesta.idBancoPregunta !== pregunta.idBancoPregunta)
                
                //Registro
                let respuestasConyuge = state.conyuge.respuestas
                if(valor === 2) {
                    respuestasConyuge.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: 1
                    })
                }

                setState((state) => {
                    return {
                        ...state,
                        aseguradoAdicional: {
                            ...state.aseguradoAdicional,
                            respuestas: respuestasAsegurado
                        },
                        conyuge: {
                            ...state.conyuge,
                            respuestas: respuestasConyuge
                        }
                    }
                })

                //Actualización Local
                let respuestasDetalle = localState.respuestasDetalle.map((respuestaDetalleLoc, indexLoc) => {
                    if(index === indexLoc) {
                        respuestaDetalleLoc.codigoAsegurado = valor
                    }
                    return respuestaDetalleLoc
                })

                setLocalState((localState) => {
                    return {
                        ...localState,
                        respuestasDetalle: respuestasDetalle
                    }
                })
            } else if(respuestaDetalle.codigoAsegurado === 2) {
                //Actualización Global
                //Eliminación
                let respuestasConyuge = state.conyuge.respuestas.filter(respuesta => respuesta.idBancoPregunta !== pregunta.idBancoPregunta)
                
                //Registro
                let respuestasAsegurado = state.aseguradoAdicional.respuestas
                if(valor === 1) {
                    respuestasAsegurado.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: 1
                    })
                }

                setState((state) => {
                    return {
                        ...state,
                        aseguradoAdicional: {
                            ...state.aseguradoAdicional,
                            respuestas: respuestasAsegurado
                        },
                        conyuge: {
                            ...state.conyuge,
                            respuestas: respuestasConyuge
                        }
                    }
                })

                //Actualización Local
                let respuestasDetalle = localState.respuestasDetalle.map((respuestaDetalleLoc, indexLoc) => {
                    if(index === indexLoc) {
                        respuestaDetalleLoc.codigoAsegurado = valor
                    }
                    return respuestaDetalleLoc
                })
                
                setLocalState((localState) => {
                    return {
                        ...localState,
                        respuestasDetalle: respuestasDetalle
                    }
                })
            } else if(respuestaDetalle.codigoAsegurado === 0) {
                //Registro Global
                let respuestasAsegurado = state.aseguradoAdicional.respuestas
                let respuestasConyuge = state.conyuge.respuestas ? state.conyuge.respuestas : []
                if(valor === 1) {
                    respuestasAsegurado.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: 1
                    })
                } else if(valor === 2) {
                    respuestasConyuge.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: 1
                    })
                }
                setState((state) => {
                    return {
                        ...state,
                        aseguradoAdicional: {
                            ...state.aseguradoAdicional,
                            respuestas: respuestasAsegurado
                        },
                        conyuge: {
                            ...state.conyuge,
                            respuestas: respuestasConyuge
                        }
                    }
                })

                //Registro Local
                let respuestasDetalle = localState.respuestasDetalle.map((respuestaDetalleLoc, indexLoc) => {
                    if(index === indexLoc) {
                        respuestaDetalleLoc.codigoAsegurado = valor
                    }
                    return respuestaDetalleLoc
                })
                setLocalState((localState) => {
                    return {
                        ...localState,
                        respuestasDetalle: respuestasDetalle
                    }
                })
            }
        }
    }

    return (
        <React.Fragment>
            <Modal
                mostrarModal={mostrarModa}
                setModal={setMostrarModa}
                textos={localState.textos} />
            
            {tipo === 1
                ? <React.Fragment>
                    {localState.otrosSeguros.map((otroSeguro, index) => {
                    return (
                        <div key={index}>
                            {localState.otrosSeguros.length - 1 === index
                                && <div className={styles['añadirDiv']}>
                                    <div>
                                        <button
                                            className={Deshabilitar() !== true ? styles['btn-insertar'] : styles['btn-insertar-oculto']}
                                            onClick={localState.otrosSeguros.length > 9 ? (e) => mostrarPopup(1) : handleAgregarUno}>
                                                <span>+</span>
                                                Insertar
                                        </button>
                                    </div>
                                </div>
                            }
    
                            <br/>
                            <div>
                                <div className={styles['adicional1Div']}>
                                    <label className={styles['adicional1Label']}>Titular del seguro</label>
                                </div>
                                <div className={styles['adicional1Div']}>
                                    <label className={styles['adicional1LabelA']}>
                                        <input
                                            type='radio'
                                            value={1}
                                            selected={otroSeguro.codigoTipoAsegurado !== null && otroSeguro.codigoTipoAsegurado === 1}
                                            checked={otroSeguro.codigoTipoAsegurado === 1}
                                            onChange={(e) => handleChangeTitular(e, 'codigoTipoAsegurado', index)}
                                            disabled={Deshabilitar() !== true ? false : true}
                                        />
                                        <p>Principal</p>
                                    </label>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <label className={styles['adicional1LabelA']}>
                                        <input
                                            type='radio'
                                            value={2}
                                            selected={otroSeguro.codigoTipoAsegurado !== null && otroSeguro.codigoTipoAsegurado === 2}
                                            checked={otroSeguro.codigoTipoAsegurado === 2}
                                            onChange={(e) => handleChangeTitular(e, 'codigoTipoAsegurado', index)}
                                            disabled={Deshabilitar() !== true ? false : true}
                                        />
                                        <p>Cónyuge</p>
                                    </label>
                                    {localState.otrosSeguros.length !== 1 && (
                                        <img
                                            className={styles['btn-grid2']}
                                            src={btnEliminar}
                                            alt=''
                                            onClick={() => handleDeleteAdicionalUno(index)}
                                            style={{pointerEvents: Deshabilitar() === true ? 'none' : 'auto'}}
                                        />
                                    )}
                                </div>
                                {state.campoValidadoAdicional.titular.length > 0 && !state.campoValidadoAdicional.titular[index] ? (
                                    <span className={styles['error-radio-titular']}>{Constantes.MENSAJE_OBLIGATORIO}</span>
                                ) : null}
                                <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                                    <div className={styles['area50']}>
                                        <label>Compañía</label>
                                        <input
                                            className={state.campoValidadoAdicional.compania.length > 0 && !state.campoValidadoAdicional.compania[index]
                                                ? styles['error-input'] : null}
                                            type='text'
                                            value={otroSeguro.compania}
                                            onChange={(e) => handleChangeTexto(e, 'compania', index)}
                                            disabled={Deshabilitar() !== true ? false : true}
                                            maxLength={50}
                                        />
                                        {state.campoValidadoAdicional.compania.length > 0 && !state.campoValidadoAdicional.compania[index] ? (
                                            <span className={styles['error']}>{Constantes.MENSAJE_COMPANIA}</span>
                                        ) : null}
                                    </div>
                                    <div className={styles['area25']}>
                                        <label>Año de emisión</label>
                                        <input
                                            className={state.campoValidadoAdicional.emision.length > 0 && !state.campoValidadoAdicional.emision[index]
                                                ? styles['error-input'] : null}
                                            type='text'
                                            maxLength={4}
                                            value={otroSeguro.anioEmision || ''}
                                            onChange={(e) => handleAnio(e, 'anioEmision', index)}
                                            disabled={Deshabilitar() !== true ? false : true}
                                        />
                                        {state.campoValidadoAdicional.emision.length > 0 && !state.campoValidadoAdicional.emision[index] ? (
                                            <span className={styles['error']}>{Constantes.MENSAJE_ANIO_EMISION}</span>
                                        ) : null}
                                    </div>    
                                    <div className={styles['area25']}>
                                        <label>Tipo de plan</label>
                                        <input
                                            className={state.campoValidadoAdicional.tipoPlan.length > 0 && !state.campoValidadoAdicional.tipoPlan[index]
                                                ? styles['error-input'] : null}
                                            type='text'
                                            value={otroSeguro.tipoPlan}
                                            onChange={(e) => handleChangeTexto(e, 'tipoPlan', index)}
                                            disabled={Deshabilitar() !== true ? false : true}
                                            maxLength={50}
                                        />
                                        {state.campoValidadoAdicional.tipoPlan.length > 0 && !state.campoValidadoAdicional.tipoPlan[index] ? (
                                            <span className={styles['error']}>{Constantes.MENSAJE_TIPO_PLAN}</span>
                                        ) : null}
                                    </div>
                                </div>
                                <div className={`${styles['grupodeform3']} ${styles['top18']}`}>
                                    <div className={styles['area50']}>
                                        <label className={styles['grupodeform3-label']}>Suma Asegurada</label>
                                        <input
                                            className={state.campoValidadoAdicional.sumaAsegurada.length > 0 && !state.campoValidadoAdicional.sumaAsegurada[index]
                                                ? styles['error-input'] 
                                                : styles['grupodeform3-input']
                                            }
                                            type='text'
                                            value={Funciones.formatoMoneda(otroSeguro.sumaAsegurada)}
                                            onChange={(e) => handleChangeSuma(e, 'sumaAsegurada', index)}
                                            disabled={Deshabilitar() !== true ? false : true}
                                            maxLength={19}
                                        />
                                        {state.campoValidadoAdicional.sumaAsegurada.length > 0 && !state.campoValidadoAdicional.sumaAsegurada[index] ? (
                                            <span className={styles['error']}>{Constantes.MENSAJE_SUMA_ASEGURADA}</span>
                                        ) : null}
                                    </div>
                                    <div className={styles['area60']}>
                                        <label className={styles['grupodeform3-label2']}>Préstamo</label>
                                        <div className={styles['adicionalPrestamo']}>
                                            <label className={styles['grupodeform3-label']}>
                                                <input
                                                    className={styles['radio1']}
                                                    type='radio'
                                                    value={1}
                                                    selected={otroSeguro.prestamo !== null && otroSeguro.prestamo === 1}
                                                    checked={otroSeguro.prestamo === 1}
                                                    onChange={(e) => handleChangePrestamo(e, 'prestamo', index)}
                                                    disabled={Deshabilitar() !== true ? false : true}
                                                />
                                                <p className={styles['grupodeform3-p1']}>Sí</p>
                                            </label>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <label className={styles['grupodeform3-label']}>
                                                <input
                                                    className={styles['radio2']}
                                                    type='radio'
                                                    value={0}
                                                    selected={otroSeguro.prestamo !== null && otroSeguro.prestamo === 0}
                                                    checked={otroSeguro.prestamo === 0}
                                                    onChange={(e) => handleChangePrestamo(e, 'prestamo', index)}
                                                    disabled={Deshabilitar() !== true ? false : true}
                                                />
                                                <p className={styles['grupodeform3-p2']}>No</p>
                                            </label>
                                        </div>
                                        {state.campoValidadoAdicional.prestamo.length > 0 && !state.campoValidadoAdicional.prestamo[index] ? (
                                            <span className={styles['error-radio']}>{Constantes.MENSAJE_OBLIGATORIO}</span>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}</React.Fragment>
                : null
            }

            {tipo === 2
                ? <React.Fragment>
                    {localState.respuestasDetalle.map((respuestaDetalle, index) => {
                        return (
                            <div key={index}>
                                <div className={styles['añadirDiv']}>
                                    {localState.respuestasDetalle.length - 1 === index &&
                                        <div>
                                            <button
                                                className={Deshabilitar() !== true ? styles['btn-insertar'] : styles['btn-insertar-oculto']}
                                                onClick={pregunta.listaAsegurados.length < localState.respuestasDetalle.length + 1
                                                    ? (e) => mostrarPopup(2) : handleAgregarDos}>
                                                <span>+</span>
                                                Insertar
                                            </button>
                                        </div>
                                    }
                                </div>
                                <div className={styles['adicionalDetalle']}>
                                    <div className={`${styles['grupodeform']} ${styles['top18']}`}>
                                        <div className={styles['area50']}>
                                            <label>Asegurado</label>
                                            <select 
                                                className={!state.campoValidadoAdicional.tipoAsegurado
                                                    ? styles['error-input'] : styles['selectAdicional']}
                                                onChange={(e) => handleChangeCombo(e, 'codigoAsegurado', index, respuestaDetalle)}
                                                value={respuestaDetalle.codigoAsegurado}
                                                disabled={Deshabilitar() !== true ? false : true}>
                                                <option value={0}>Seleccione</option>
                                                {pregunta.listaAsegurados.map(asegurado => (
                                                    <option key={asegurado.codigoAsegurado} value={asegurado.codigoAsegurado}>
                                                        {asegurado.parentesco + ': ' + asegurado.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {!state.campoValidadoAdicional.tipoAsegurado ? (
                                                <span className={styles['error-radio-titular']}>{Constantes.MENSAJE_OBLIGATORIO}</span>
                                            ) : null}
                                        </div>
                                        {localState.respuestasDetalle.length !== 1 && (
                                            <img
                                                className={styles['btn-grid']}
                                                src={btnEliminar}
                                                alt=''
                                                onClick={() => handleDeleteAdicionalDos(index, respuestaDetalle)}
                                                style={{pointerEvents: Deshabilitar() === true ? 'none' : 'auto'}}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </React.Fragment>
                : null
            }
        </React.Fragment>
    )
}

export default DetallePreguntaAdicional